// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BadgeText from './styles/ZoneSixBadges.style';

const ZoneSixBadges = (props) => {
  const { className, text } = props;
  return (
    <BadgeText
      fontFamily="secondary"
      fontSize={['fs10', 'fs10', 'fs12']}
      className={`${className} zone-six-label`}
    >
      {text?.toLowerCase()}
    </BadgeText>
  );
};

ZoneSixBadges.defaultProps = {
  className: '',
};

ZoneSixBadges.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
};

export default ZoneSixBadges;
